import {AnySheet} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';

export class SheetSlotLocation
{
    public constructor(public readonly sheet:AnySheet,
                       public readonly colIndex:number,
                       public readonly rowIndex:number)
    {
    }
}
